export const gs8_contestants = {
    "amateurs": [
        {
            "name": "Crosby Schultz",
            "nickname": "Crozbaby",
            "experience": 1,
            "finishes": [
                {
                    "food": "Gyoza",
                    "year": 2025,
                    "rank": "Professional",
                    "place": 8
                }
            ],
            "campaignUrl": "https://go.dojiggy.io/a46932/m/crozbaby/Member/Details",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/athletes/amateurs/Crosby.jpg"
        },
        {
            "name": "Micheal Pascua",
            "experience": 1,
            "finishes": [
                {
                    "food": "Gyoza",
                    "year": 2025,
                    "rank": "Professional",
                    "place": 9
                }
            ],
            "campaignUrl": "https://go.dojiggy.io/a46932/m/pascua/Member/Details",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/athletes/amateurs/Michael.jpg"
        },
        {
            "name": "Dan W",
            "nickname": "The Void",
            "experience": 1,
            "finishes": [
                {
                    "food": "Mini Donuts",
                    "year": 2024,
                    "rank": "Professional",
                    "place": 6
                }
            ],
            "campaignUrl": "https://go.dojiggy.io/a46932/m/thevoid/Member/Details",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/athletes/amateurs/DanW.jpg"
        },
        {
            "name": "Rosa Mestas",
            "nickname": "Dallas' Mom",
            "experience": 1,
            "finishes": [
                {
                    "food": "Mini Donuts",
                    "year": 2024,
                    "rank": "Amateur",
                    "place": 10
                }
            ],
            "campaignUrl": "https://go.dojiggy.io/nocrust/m/8d8834",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/athletes/amateurs/Rosa.jpg"
        },
        {
            "name": "Mathias Deeg",
            "nickname": "Sweet Cream",
            "experience": 0,
            "campaignUrl": "https://go.dojiggy.io/nocrust/m/sweetcream",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/athletes/amateurs/MathiasDeeg.jpg"
        },
        {
            "name": "Jon Pendleton",
            "nickname": "The Sleeper",
            "experience": 0,
            "campaignUrl": "https://go.dojiggy.io/nocrust/m/jonp",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/athletes/amateurs/JonPendleton.jpg"
        },
        {
            "name": "Raul Melgarejo",
            "nickname": "Gullet Mullet",
            "experience": 0,
            "campaignUrl": "https://go.dojiggy.io/nocrust/m/gulletmullet",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/athletes/amateurs/Raul.jpg"
        },
        {
            "name": "Diontaé Harden",
            "nickname": "Dark Knight",
            "experience": 0,
            "campaignUrl": "https://go.dojiggy.io/nocrust/m/darkknight",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/athletes/amateurs/Dionte%CC%81.jpg"
        },
        {
            "name": "Madi Hinkel",
            "nickname": "HumuHumu",
            "experience": 0,
            "campaignUrl": "https://go.dojiggy.io/nocrust/m/hinkel",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/athletes/amateurs/Madi.jpg"
        },
        {
            "name": "Scott Petrushka",
            "nickname": "The Gobbler",
            "experience": 0,
            "campaignUrl": "https://go.dojiggy.io/nocrust/m/thegobbler",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/athletes/amateurs/scott%20p.jpg"
        },
        {
            "name": "Kamran Abri",
            "nickname": "Karnivorous Kami",
            "experience": 0,
            "campaignUrl": "https://go.dojiggy.io/nocrust/m/506204",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/athletes/amateurs/kamranabri.jpg"
        }
    ],
    "pros": [
        {
            "name": "Naader Reda",
            "nickname": "Freak Eating",
            "experience": 1,
            "finishes": [
                {
                    "food": "Gyoza",
                    "year": 2025,
                    "rank": "Professional",
                    "place": 1
                }
            ],
            "campaignUrl": "https://go.dojiggy.io/nocrust/m/freak",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/athletes/pros/Naader.jpg"
        },
        {
            "name": "Miles Zoltak",
            "nickname": "Ahead",
            "experience": 1,
            "finishes": [
                {
                    "food": "Gyoza",
                    "year": 2025,
                    "rank": "Professional",
                    "place": 2
                }
            ],
            "campaignUrl": "https://go.dojiggy.io/nocrust/m/miles",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/athletes/pros/Miles.jpg"
        },
        {
            "name": "Sam Shirley",
            "nickname": "Sammy Mermaid",
            "experience": 2,
            "finishes": [
                {
                    "food": "Mini Donuts",
                    "year": 2024,
                    "rank": "Professional",
                    "place": 4
                },
                {
                    "food": "Gyoza",
                    "year": 2025,
                    "rank": "Professional",
                    "place": 3
                }
            ],
            "campaignUrl": "https://go.dojiggy.io/nocrust/m/mermaid",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/athletes/pros/Sam.jpg"
        },
        {
            "name": "Jeremy Katz",
            "nickname": "Jaws of Jersey",
            "experience": 1,
            "finishes": [
                {
                    "food": "Gyoza",
                    "year": 2025,
                    "rank": "Professional",
                    "place": 4
                }
            ],
            "campaignUrl": "https://go.dojiggy.io/nocrust/m/jaws",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/athletes/pros/Jeremy%20(1).jpg"
        },
        {
            "name": "Kenney Tran",
            "nickname": "The People's Musubi",
            "experience": 1,
            "finishes": [
                {
                    "food": "Gyoza",
                    "year": 2025,
                    "rank": "Professional",
                    "place": 7
                }
            ],
            "campaignUrl": "https://go.dojiggy.io/nocrust/m/thepeoplesmusubi",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/athletes/pros/Kenney.jpg"
        },
        {
            "name": "Oden",
            "experience": 2,
            "finishes": [
                {
                    "food": "Mini Donuts",
                    "year": 2024,
                    "rank": "Professional",
                    "place": 5
                },
                {
                    "food": "Gyoza",
                    "year": 2025,
                    "rank": "Professional",
                    "place": 7
                }
            ],
            "campaignUrl": "https://go.dojiggy.io/nocrust/m/734514",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/athletes/pros/Oden.jpg"
        },
        {
            "name": "Jessamyn Reichmann",
            "nickname": "Seattle's Sweetheart",
            "experience": 1,
            "finishes": [
                {
                    "food": "Gyoza",
                    "year": 2025,
                    "rank": "Amateur",
                    "place": 1
                }
            ],
            "campaignUrl": "https://go.dojiggy.io/nocrust/m/sweetheart",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/athletes/pros/Jessamyn.jpg"
        },
        {
            "name": "Jonathan Gong",
            "nickname": "Jon Boat",
            "experience": 0,
            "finishes": [],
            "campaignUrl": "https://go.dojiggy.io/nocrust/m/jonboat",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/athletes/pros/Gong%20The%20GodFather%20of%20Uncrustables.jpg"
        },
        {
            "name": "Ashwin Muthy",
            "nickname": "Dark Horse",
            "experience": 0,
            "finishes": [],
            "campaignUrl": "https://go.dojiggy.io/nocrust/m/darkhorse",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/athletes/pros/AshwinMurthy.jpg"
        },
        {
            "name": "Miller Michaud",
            "nickname": "The Crust Redeemer",
            "experience": 0,
            "finishes": [],
            "campaignUrl": "https://go.dojiggy.io/nocrust/m/redeemer",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/athletes/pros/Miller%20Michaud%20(The%20Crust%20Redeemer).jpg"
        },
    ]
}

export const gs7_contestants = gs8_contestants;
